export default "__VITE_ASSET__7mskXRkd__"